import { graphql } from '@api/mesa'

export const PLAID_GENERATE_LINK_TOKEN = graphql(`
  query GenerateLinkToken(
    $products: [Products!]
    $itemId: String
    $accountId: String
    $isAndroid: Boolean
  ) {
    generateLinkToken(
      products: $products
      itemId: $itemId
      accountId: $accountId
      isAndroid: $isAndroid
    ) {
      linkToken
      expiration
      requestId
    }
  }
`)

/** @todo deprecate this in favor of just using `usePlaidLinkForMesaHomeEnrollment` */
export const GET_PLAID_LINK_TOKEN_FOR_MORTGAGE_EARN = graphql(`
  query GenerateLinkTokenForMortgageEarn($isAndroid: Boolean) {
    generateLinkToken(products: [Transactions], isAndroid: $isAndroid) {
      linkToken
      expiration
      requestId
    }
  }
`)

export const GET_PLAID_LINKED_ACCOUNTS = graphql(`
  query GetPlaidLinkedAccounts {
    linkedAccounts {
      id
      name
      mask
      itemId
      type
      subtype
      institutionName
      products
      consentedProducts
      billedProducts
      availableProducts
      verificationStatus
      isTransactionsActive
      isAuthActive
    }
  }
`)
